import {createFileRoute} from '@tanstack/react-router'
import {ErrorTransaction} from "@/components/wallet/TransactionStatuses/ErrorTransaction/ErrorTransaction"

export const Route = createFileRoute('/_mainLayout/wallet/transaction-error/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ErrorTransaction/>
}
